import { useCallback } from 'react'
import { profileGet } from '@chilipiper/service/src/api'

export const useImageResolver = (id: string) =>
  useCallback(async () => {
    if (id === '') {
      return Promise.reject('ID not defined')
    }

    const response = await profileGet(`profile/${id}`).json<{ image: string }>()

    return response.image
  }, [id])
